// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/four-forces.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/four-forces/four-forces.js';

mount([g0]);
